<template>
  <div class="cochain">
    <div class="part-1">
      <div class="main">
        <div class="left">
          <span class="tit">Co-Chain</span>
          <p>{{ $t('cochain.slider1.description') }}</p>
          <!-- <div class="whitebook">
            <a v-show="downcn" href = "http://sdchain-iot.com/download/Resource_2/whitepaper_SC.pdf">
              {{ $t('cochain.slider1.white') }}
              <i class="iconfont icon-xiazai1"></i>
            </a>
             <a v-show="downen" href = "http://sdchain-iot.com/download/Resource_2/whitepaper_EN.pdf">
              {{ $t('cochain.slider1.white') }}
              <i class="iconfont icon-xiazai1"></i>
            </a>
             <a  v-show="downft" href = "http://sdchain-iot.com/download/Resource_2/whitepaper_TC.pdf">
              {{ $t('cochain.slider1.white') }}
              <i class="iconfont icon-xiazai1"></i>
            </a>
          </div> -->
        </div>
        <div class="right">
          <img src="../assets/images/cochain-right.png" alt>
        </div>
      </div>
    </div>

    <div class="part-2">
      <div class="main">
        <p class="tit">{{ $t('cochain.part1.head1') }}</p>
        <p class="desc">{{ $t('cochain.part1.head2') }}</p>
        <div class="row-1">
          <div class="item">
            <div class="img">
              <img src="../assets/images/cochain/1.png" alt="">
            </div>
            <div class="content">
              <span>{{ $t('cochain.part1.title1') }}</span>
              <p>{{ $t('cochain.part1.description1') }}</p>
            </div>
          </div>
          <div class="item">
            <div class="img">
              <img src="../assets/images/cochain/2.png" alt="">
            </div>
            <div class="content">
              <span>{{ $t('cochain.part1.title2') }}</span>
              <p>{{ $t('cochain.part1.description2') }}</p>
            </div>
          </div>
          <div class="item">
            <div class="img">
              <img src="../assets/images/cochain/3.png" alt="">
            </div>
            <div class="content">
              <span>{{ $t('cochain.part1.title3') }}</span>
              <p>{{ $t('cochain.part1.description3') }}</p>
            </div>
          </div>
        </div>
        <div class="row-2">
          <div class="item">
            <div class="img">
              <img src="../assets/images/cochain/4.png" alt="">
            </div>
            <div class="content">
              <span>{{ $t('cochain.part1.title4') }}</span>
              <p>{{ $t('cochain.part1.description4') }}</p>
            </div>
          </div>
          <div class="item">
            <div class="img">
              <img src="../assets/images/cochain/5.png" alt="">
            </div>
            <div class="content">
              <span>{{ $t('cochain.part1.title5') }}</span>
              <p>{{ $t('cochain.part1.description5') }}</p>
            </div>
          </div>
          <div class="item">
            <div class="img">
              <img src="../assets/images/cochain/6.png" alt="">
            </div>
            <div class="content">
              <span>{{ $t('cochain.part1.title6') }}</span>
              <p>{{ $t('cochain.part1.description6') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="part-3">
      <div class="main">
        <p class="tit">{{ $t('cochain.part2.head1') }}</p>
        <p class="desc">{{ $t('cochain.part2.head2') }}</p>
        <div class="six">

          <img src="../assets/images/cochain-part3.png" alt>

          <div class="c-1 content">
            <p>{{ $t('cochain.part2.title1') }}</p>
            <p>{{ $t('cochain.part2.description1') }}</p>
          </div>
          <div class="c-2 content">
            <p>{{ $t('cochain.part2.title4') }}</p>
            <p>{{ $t('cochain.part2.description4') }}</p>
          </div>
          <div class="c-3 content">
            <p>{{ $t('cochain.part2.title6') }}</p>
            <p>{{ $t('cochain.part2.description6') }}</p>
          </div>
          <div class="c-4 content">
            <p>{{ $t('cochain.part2.title5') }}</p>
            <p>{{ $t('cochain.part2.description5') }}</p>
          </div>
          <div class="c-5 content">
            <p>{{ $t('cochain.part2.title2') }}</p>
            <p>{{ $t('cochain.part2.description2') }}</p>
          </div>
          <div class="c-6 content">
            <p>{{ $t('cochain.part2.title3') }}</p>
            <p>{{ $t('cochain.part2.description3') }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="part-4">
      <div class="main">
        <p class="tit">{{ $t('cochain.part3.head1') }}</p>
        <p class="desc">{{ $t('cochain.part3.head2') }}</p>
        <div class="cont">
          <div class="flu">
            <span>{{ $t('cochain.part3.title1') }}</span>
            <p>{{ $t('cochain.part3.description1') }}</p>
          </div>
          <div class="flu">
            <span>{{ $t('cochain.part3.title2') }}</span>
            <p>{{ $t('cochain.part3.description2') }}</p>
          </div>
          <div class="flu">
            <span>{{ $t('cochain.part3.title3') }}</span>
            <p>{{ $t('cochain.part3.description3') }}</p>
          </div>
        </div>
        <div class="btn">
          <a v-show="iconcn" href="https://cochain.sdchain.io/cochain" target="_blank">{{ $t('cochain.part3.btn1') }}<i class="iconfont icon-youjiantou-copy"></i></a>
            <a  style="padding: 15px 110px;"  v-show="iconen" href="https://cochain.sdchain.io/cochain" target="_blank">{{ $t('cochain.part3.btn1') }}<i class="iconfont icon-youjiantou-copy"></i></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  components: {},
  data() {
    return {
      loading: false,
      nowtime: null,
      totalVal: 0,
      passVal: 0,
      heightVal: 0,
      tradeVal: 0,
      data1: [],
      data2: [],
      downcn:false,
      downen:false,
      downft:false,
      iconcn:false,
      iconen:false,
    };
  },
  created() {
  this.getDown();
  },
  mounted() {},
  methods: {
    getDown() {
        if( localStorage.Lang == "cn"){
          this.downcn =  true;
          this.iconcn =  true; 
        }else  if( localStorage.Lang == "tw"){
          this.downft = true;
          this.iconcn = true;
        }else {
          this.downen= true;
          this.iconen = true;
        }    
    },
  },
};
</script>
<style lang="less" scoped>
@import url("../assets/css/var.less");
.cochain {
  .part-1 {
    background:linear-gradient(81deg,rgba(24,73,200,1),rgba(47,114,224,1));
    height: 599px;
    .clearfix();
    .left {
      float: left;
      width: 50%;
      text-align: right;
      padding-right: 20px;
      padding-left: 6%;
      vertical-align: middle;
      color: #fff;

      .tit {
        display: block;
        margin-top: 250px;
        text-align: left;
        font-size:66px;
        font-weight:400;
        color:rgba(255,255,255,1);
        
      }
      p {
        padding:  0;
        text-align: left;
        font-size:22px;
        font-weight:400;
        color:rgba(255,255,255,1);
        
        // margin-top: 10px;
      }
      .whitebook {
        margin-top: 15px;
        text-align: left;
        width:240px;
        height: 56px;
        background-color: #fff;
        text-align: center;
        line-height: 56px;
        cursor: pointer;
        a {
          font-size:20px;
          
          font-weight:300;
          color:rgba(80,145,253,1);
          text-shadow:0px 6px 67px rgba(44,29,29,0.49);
          i{
            font-size:24px;
          }
        }
      }
    }
    .right {
      float: left;
      width: 50%;
      text-align: left;
      vertical-align: middle;
      margin-top: 150px;
      padding-left: 20px;
      img {
        width: 472px;
        height: 399px;
      }
    }
  }
  .part-2 {
    height: 621px;
    background-color: #f7faff;
    .main{
      overflow: hidden;
      height: 100%;
      padding: 0;
    }
    .fenge {
      .fgx();
    }
    .tit {
      font-size:36px;
    
      font-weight:400;
      color:rgba(68,67,67,1);
      margin-top: 80px;
      text-align: center;
    }
    .desc {
      font-size:20px;
     
      font-weight:400;
      color:rgba(85,85,85,1);
      text-align: center;
      margin-top: 15px;
    }
    .row-1 {
      margin-top: 50px;
      display: flex;
      .item {
        height:160px;
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 10px 0px rgba(0, 0, 0, 0.05);
        &:hover{
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        }
        flex: 1;
        margin: 0 5px;
        .clearfix();
        .img {
          height:138px;
          float: left;
          width: 25%;
          text-align: center;
          img{
            margin-top: 50px;
            width: 40px;
            height: 40px;
          }
        }
        .content {
          float: left;
          width: 75%;
          span {
            padding-right: 25px;
            display: block;
            font-size:24px;
        
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:70px;
          }
          p {
            //text-align: justify;
            text-align: left;
            padding-right: 25px;
            font-size:16px;
         
            font-weight:400;
            color:rgba(85,85,85,1);
            line-height:24px;
            margin-top: -12px;
          }
        }
      }
    }
    .row-2 {
      margin-top: 30px;
      display: flex;
      .item {
        flex: 1;
        margin: 0 5px;
        height:160px;
        background:rgba(255,255,255,1);
       box-shadow:0px 0px 10px 0px rgba(0, 0, 0, 0.05);
        &:hover{
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        }
        .clearfix();
        .img {
          height:138px;
          float: left;
          width: 25%;
          text-align: center;
          img{
            margin-top: 50px;
            width: 40px;
            height: 40px;
          }
        }
        .content {
          float: left;
          width: 75%;
          span {
            display: block;
            padding-right: 25px;
            font-size:24px;
       
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:70px;
          }
          p {
            padding-right: 25px;
            font-size:16px;
        
            font-weight:400;
            color:rgba(85,85,85,1);
            line-height:24px;
            margin-top: -12px;
          }
        }
      }
    }
  }
  .part-3 {
    width: 100%;
    height: 1060px;
    background-color: #fff;
    .main{
      overflow: hidden;
      height: 100%;
      padding: 0;
    }
    .fenge {
      .fgx();
    }
    .tit {
      font-size:36px;

      font-weight:400;
      color:rgba(51,51,51,1);
      margin-top: 90px;
      text-align: center;
    }
    .desc {
      font-size:20px;
   
      font-weight:400;
      color:rgba(85,85,85,1);
      margin-top: 15px;
      text-align: center;
    }
    .six {
      position: relative;
      height: 600px;
      top: 100px;
      img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
      .content {
        width: 250px;
        p{
          &:nth-child(1){
            font-size:24px;
      
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:51px;
          }
          &:nth-child(2){
            font-size:16px;
           // text-align: justify;
            text-align: left;
         
            font-weight:400;
            color:rgba(85,85,85,1);
          }
        }
        &.c-1 {
          position: absolute;
          text-align: left;
          left: 27%;
          top:0%;
          transform: translate(-5%, -28%);
        }
        &.c-2 {
          position: absolute;
          text-align: left;
          left: 76%;
          top: 100%;
          transform: translate(-100%, -75%);
        }
        &.c-3 {
          position: absolute;
          text-align: left;
          left: 10%;
          top: 26%;
          transform: translate(-22%, -13%);
        }
        &.c-4 {
          position: absolute;
          text-align: left;
          left: 20%;
          top: 62%;
          transform: translate(-68%, -18%);
        }
        &.c-5 {
          position: absolute;
          text-align: left;
          left: 79%;
          top: 38%;
          transform: translate(-22%, -83%);
        }
        &.c-6 {
          position: absolute;
          text-align: left;
          left: 89%;
          top: 74%;
          transform: translate(-68%, -90%);
        }
        p {
          &:nth-child(1) {
          }
          &:nth-child(2) {
          }
        }
      }
    }
  }
  .part-4 {
    height: 875px;
    background-color: #F7FAFF;
    .fenge {
      .fgx();
    }
    .tit {
      font-size:36px;

      font-weight:400;
      color:rgba(51,51,51,1);
      margin-top: 90px;
      text-align: center;
    }
    .desc {
      font-size:20px;
 
      font-weight:400;
      color:rgba(85,85,85,1);
      margin-top: 15px;
      text-align: center;
    }
    .cont {
      display: flex;
      justify-content: space-between;
      margin-top: 55px;
      .flu {
        width: 320px !important;
        height: 460px;
       
        &:nth-child(1) {
          background-image: url("../assets/images/cochain-part4-1.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          span{
            display: block;
            margin: 0 20px;
            border-bottom: 1px solid #fff;
            padding-top: 100px;
            padding-bottom: 5%;
            font-size:30px;
          
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:46px;
            white-space: pre-wrap;
          }
          p{
            //text-align: justify;
            text-align: left;
            padding:0 20px;
            padding-top: 25px;
            font-size:16px;
      
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:30px;
          }
        }
        &:nth-child(2) {
          background-image: url("../assets/images/cochain-part4-2.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          span{
            display: block;
            margin: 0 20px;
            border-bottom: 1px solid #fff;
            padding-top: 100px;
            padding-bottom: 5%;
            font-size:30px;
           
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:46px;
              white-space: pre-wrap;
          }
          p{
            padding:0 20px;
            padding-top: 25px;
            font-size:16px;
        
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:30px;
          }
        }
        &:nth-child(3) {
          background-image: url("../assets/images/cochain-part4-3.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          span{
            display: block;
            margin: 0 20px;
            border-bottom: 1px solid #fff;
            padding-top: 100px;
            padding-bottom: 5%;
            font-size:30px;
     
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:46px;
              white-space: pre-wrap;
          }
          p{
            padding:0 20px;
            padding-top: 25px;
            font-size:16px;
          
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:30px;
          }
        }
         &:hover{
          background-image: none;
          background-color: #5091FD;
          border-radius: 16px;
        }
      }
    }
    .btn {
      text-align: center;
      margin-top: 95px;
      a {
        padding: 15px 38px;
        background-color: #5191fd;
        border-radius: 2px;
        letter-spacing: 1px;
        font-size:20px;

        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:71px;
        i{
          font-size: 20px;
          display: inline-block;
          vertical-align: middle;
        }
      }
    }
  }
}
</style>
